import React from 'react';
import ReactDOM from 'react-dom';

export const Portal = ({ children }: { children: React.ReactNode }) => {
  const [container, setContainer] = React.useState<HTMLDivElement | null>(null);

  React.useEffect(() => {
    const portalContainer = document.createElement('div');
    document.body.appendChild(portalContainer);
    setContainer(portalContainer);

    return () => {
      document.body.removeChild(portalContainer);
    };
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(children, container);
};
